/*
  JS propio de Nuchas. Se carga desde snippets/javascript.liquid después de
  vendor.js (jQuery, lodash) y colors.js, así que $ y Colors ya existen.
  Este archivo es un .js estático: Liquid no se procesa aquí. Los datos de la
  tienda deben llegar por data-attributes o por window.Colors.strings.
*/
window.Nuchas = window.Nuchas || {};

(function($, Nuchas) {
  'use strict';

  Nuchas.init = function() {
    // Los módulos nuevos se registran aquí.
  };

  $(function() {
    Nuchas.init();
  });

  // Re-inicializar secciones cuando se editan desde el theme editor.
  $(document).on('shopify:section:load', function() {
    Nuchas.init();
  });
})(jQuery, window.Nuchas);
